import { createRouter, createWebHashHistory } from 'vue-router'
import Bit from '../views/Bit'
import Login from "@/views/Login";
import Forgot from "@/views/Forgot";
import Register from "@/views/Register";
import Positions from "@/views/Positions";
import TeleBot from '../views/telebot'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Bit
  },
  {
    path: '/bit',
    name: 'Bit',
    component: Bit
  },
  {
    path: '/lk',
    name: 'LK',
    component: Bit
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/forgot',
    name: 'Forgot',
    component: Forgot
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    children: [
      {
        // UserProfile will be rendered inside User's <router-view>
        // when /user/:id/profile is matched
        path: ':referral',
        component: Register,
      },]
  },
  {
    path: '/positions',
    name: 'Positions',
    component: Positions
  },
  {
    path: '/telebot',
    name: 'TeleBot',
    component: TeleBot
  },
 /* {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( `webpackChunkName: "about" ` '../views/About.vue')
  }*/
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
